module.exports = __webpack_public_path__ + "static/media/linha-profissional.a7add8e5.jpg";